module.exports = __webpack_public_path__ + "static/media/babyShower.4370c8f7.png";